const state = {

    CourseList        : [],
    CourseDetailsList : [],
    CourseSections    : [],
    CourseSEO         : [],
    CourseCurriculam  : [],
    CourseFAQs        : [],
    CourseFeatures    : [],
    
}

const mutations = {
    SetCourseList(state, payload) {

        state.CourseList = payload

    },
    SetIndividualCourse(state, payload) {

        state.CourseList.push(payload)

    },
    UpdateIndividualCourse(state, payload) {

        let index = state['CourseList'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseList'].splice(index, 1, payload)

    },
    DeleteIndividualCourse(state, payload) {

        let index = state['CourseList'].findIndex(x => x["_id"] == payload["Course_Category_Id"])
        state['CourseList'].splice(index, 1)
    },
    DeleteMultipleCourse(state, payload) {

        payload.forEach(element => {
            let index = state['CourseList'].findIndex(x => x["_id"] == element)
            state['CourseList'].splice(index, 1)
        });
    },
    SetCourseSection(state, payload) {

        if (payload) {

            state.CourseSections = payload

        } else {
            state.CourseSections = []
        }

    },
    SetCourseDetailList(state, payload) {

        state.CourseDetailsList = payload

    },
    SetIndividualCourseDetails(state, payload) {

        state.CourseDetailsList.push(payload)

    },
    UpdateCourseDetails(state, payload) {

        let index = state['CourseDetailsList'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseDetailsList'].splice(index, 1, payload)
    },
    DeleteIndividualCourseDetails(state, payload) {

        let index = state['CourseDetailsList'].findIndex(x => x["_id"] == payload)
        state['CourseDetailsList'].splice(index, 1)
    },
    AddUpdateRelatedCourse(state, payload){
        let index = state['CourseDetailsList'].findIndex(x => x["_id"] == payload["Course_Id"])
        index > 0 ? state['CourseDetailsList'][index]['Related_Courses'] = payload['Related_Courses'] : {}
    },
    DeleteRelatedCourse(state, payload){
        let index = state['CourseDetailsList'].findIndex(x => x["_id"] == payload["Course_Id"])
        index > 0 ? state['CourseDetailsList'][index]['Related_Courses'] = [] : {}
    },
    SetCourseSEO(state, payload) {

        state.CourseSEO = payload

    },
    SetIndividualCourseSEO(state, payload) {

        state.CourseSEO.push(payload)

    },
    UpdateIndividualCourseSEO(state, payload) {

        let index = state['CourseSEO'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseSEO'].splice(index, 1, payload)

    },
    DeleteIndividualCourseSEO(state, payload) {

        let index = state['CourseSEO'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseSEO'].splice(index, 1)
    },
    SetCourseCurriculamList(state, payload) {

        state.CourseCurriculam = payload

    },
    SetIndividualCourseCurriculam(state, payload) {

        state.CourseCurriculam.push(payload)

    },
    UpdateCourseCurriculam(state, payload) {

        let index = state['CourseCurriculam'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseCurriculam'].splice(index, 1, payload)
    },
    DeleteIndividualCourseCurriculam(state, payload) {

        let index = state['CourseCurriculam'].findIndex(x => x["_id"] == payload['Section_Id'])
        state['CourseCurriculam'].splice(index, 1)
    },
    SetCourseFAQsList(state, payload) {

        state.CourseFAQs = payload

    },
    SetIndividualCourseFAQs(state, payload) {

        state.CourseFAQs.push(payload)

    },
    UpdateCourseFAQs(state, payload) {

        let index = state['CourseFAQs'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseFAQs'].splice(index, 1, payload)
    },
    DeleteIndividualCourseFAQs(state, payload) {

        let index = state['CourseFAQs'].findIndex(x => x["Course_Id"] == payload)
        state['CourseFAQs'].splice(index, 1)
    },
    SetCourseFeaturesList(state, payload) {

        state.CourseFeatures = payload

    },
    SetIndividualCourseFeatures(state, payload) {

        state.CourseFeatures.push(payload)

    },
    UpdateCourseFeatures(state, payload) {

        let index = state['CourseFeatures'].findIndex(x => x["_id"] == payload["_id"])
        state['CourseFeatures'].splice(index, 1, payload)
    },
    DeleteIndividualCourseFeatures(state, payload) {

        payload.forEach(element => {
            let index = state['CourseFeatures'].findIndex(x => x["_id"] == element)
            state['CourseFeatures'].splice(index, 1)
        })
    },
}

const actions = {

}

const getters = {

    GetCourseList(state) {

        return state.CourseList
    },
    GetCourseDetailsList(state) {

        return state.CourseDetailsList
    },
    GetCourseSection(state) {

        return state.CourseSections
    },
    GetCourseSEO(state) {
        return state.CourseSEO
    },
    GetCourseCurriculamList(state) {

        return state.CourseCurriculam
    },
    GetCourseFAQsList(state){
        return state.CourseFAQs
    },
    GetCourseFeature(state){
         return state.CourseFeatures
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}